import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, ModalRef } from "@shared/components";
import { useMediaTypeOptions } from "@shared/options";

export const useBookSectorsListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  editBookSectorModalRef: RefObject<ModalRef>,
): GridColDef[] => {
  const { getMediaTypeOptions } = useMediaTypeOptions();

  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "name",
        headerName: translate("book_sector_admin.fields.name"),
        minWidth: 300,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "type",
        headerName: translate("book_sector_admin.fields.type"),
        minWidth: 120,
        headerAlign: "center",
        valueOptions: getMediaTypeOptions(),
        renderCell: ({ value }) => {
          const option = getMediaTypeOptions().find(opt => opt.value === value);
          return (
            <TableCell.Text
              value={option?.label}
              textAlign="center"
            />
          );
        },
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => editBookSectorModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, editBookSectorModalRef, getMediaTypeOptions],
  );
};
